import { render } from "./FormStep.vue?vue&type=template&id=1af56074"
import script from "./FormStep.vue?vue&type=script&lang=js"
export * from "./FormStep.vue?vue&type=script&lang=js"

import "./FormStep.vue?vue&type=style&index=0&id=1af56074&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__